<template>
  <a-modal
    :title="title"
    :width="500"
    :ok=false
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    :okText="this.$store.getters.language['common.okButton']"
    @cancel="handleCancel"
    :cancelText="language['common.closeButton']">

    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" style="margin-bottom: 0">
        <a-row>
          <a-col :span="24">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              style="margin-bottom: 0"
            >
                <a-upload
                  name="file"
                  :multiple="false"
                  :action="uploadAction"
                  :showUploadList="false"
                  :beforeUpload="beforeUpload"
                  @change="handleChange">
                  <a-button>
                    <a-icon type="upload"/>
                    {{language['common.fileUp']}}
                  </a-button>
                </a-upload>
                <a-button type="primary" icon="download" @click="ExportTemplateXls" style="left:20px">{{language['system.downloadTemplate']}}</a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row v-if="errorModel">
          <a-col :span="24">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              style="margin-bottom: 10px;margin-top: 15px"
              :label="language['common.importError']"
            >
              <!--<textarea v-model="comments" style="width:85%;border-radius: 5px;line-height: 1.5;" disabled rows="5" cols="25" maxLength="150" > </textarea>-->
              <div v-html="comments"
                   style="width:85%;border-radius: 5px;line-height: 1.5;border: 2px solid rgb(217, 217, 217);max-height: 30vh;overflow-y:scroll"></div>
            </a-form-model-item>
          </a-col>
        </a-row>



      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>

  import {putAction, getFileAccessHttpUrl,getAction,postAction,downFile} from '@/api/manage';

  export default {
    name: 'DepartUploadOrDownloadModal',
    components: {
    },
    data() {
      return {
        errorModel:false,
        // errorTitle:'导入失败',
        title:'',
        url:'',
        comments:'11',
        model:{},
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading:false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 4 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
        url: {
          upload: "/sys/sysDepart/downloadDeportXls/"+this.$store.getters.applicationCode,
        }
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      uploadAction() {
        return window._CONFIG['domianURL'] + this.url.upload;
      },
    },
    methods: {
      ExportTemplateXls(){
        let url = window._CONFIG['domianURL'] + "/sys/sysDepart/exportTemplateXls"
        // window.open(url);
        // window.location.href = url;
        downFile(url).then((data)=>{
          if (!data) {
            this.$message.warning(this.language['common.fileDowloadError'])
            return
          }
          if (typeof window.navigator.msSaveBlob !== 'undefined') {
            window.navigator.msSaveBlob(new Blob([data],{type: 'application/vnd.ms-excel'}), 'DepartExcelTemplate.xls')
          }else{
            let url = window.URL.createObjectURL(new Blob([data],{type: 'application/vnd.ms-excel'}))
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', 'DepartExcelTemplate.xls')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link); //下载完成移除元素
            window.URL.revokeObjectURL(url); //释放掉blob对象
          }
        })
      },
      beforeUpload(file) {
        var fileType = file.type;
        if (fileType === 'image') {
          if (fileType.indexOf('image') < 0) {
            this.$message.warning(this.language['warning.pleaseUploadImage']);
            return false;
          }
        } else if (fileType === 'file') {
          if (fileType.indexOf('image') >= 0) {
            this.$message.warning(this.language['warning.pleaseUploadFile']);
            return false;
          }
        }
        return true
      },
      handleChange(info) {
        if (info.file.status === 'done') {
          if (info.file.response.success) {
            // this.loadData()
            this.$message.success(`${info.file.name} `+this.language['common.uploadSuccess']);
            this.close();
            this.$emit('ok');
          } else {
            if(info.file.response.code==100||info.file.response.code==300||info.file.response.code==400){
              this.comments = info.file.response.result;
            }else if(info.file.response.code==200){
              // this.comments = info.file.response.result
              let errormap = {...info.file.response.result};
              let v = ""
              for (var key in errormap) {
                if(v == ""){
                  // v = "第"+key+"行："+map[key]+'\n';
                  v = "<p style='margin-bottom: 0'><span style='color: red'>"+key+this.language['common.strip']+"："+errormap[key]+'</span></p>';
                }else{
                  // v = v+"第"+key+"行："+map[key]+'\n';
                  v = v+"<p style='margin-bottom: 0'><span style='color: red'>"+key+this.language['common.strip']+"："+errormap[key]+'</span></p>';
                }
              }
              /*map.forEach(function (value,key) {
                if(v == ""){
                  v = "第"+key+"行："+value+'\n';
                }else{
                  v = v+"第"+key+"行："+value+'\n';
                }
              })*/
              // this.comments = v;
              this.comments = "<p style='margin-bottom: 0'><span style='font-weight:bold'>"+this.language['common.importError']+":</span></p>"+v;
                // this.$message.error(`${info.file.response.message}`);
            }
            this.errorModel = true;
          }
        } else if (info.file.status === 'error') {
          this.$message.error(`${info.file.response.message}`);
        }
      },
      add() {
        /*this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.add();
        })*/
      },
      edit(record) {
        /*this.pfBpmProcessId = record.pfBpmProcessId;
        this.workNo = record.workNo;
        this.approveAction = record.approveAction;
        this.taskCode = record.taskCode;*/
        /*this.title = record.title;
        this.comments = "";
        this.url = record.url;
        this.model = Object.assign({}, record)*/
        this.visible = true

      },
      close() {
        /*this.$emit('reSeach');
        this.$emit('close');*/
        this.visible = false;
        this.errorModel = false;
      },
      handleOk() {
        // this.$refs.realForm.submitForm();
        this.close()
      },

      submitCallback() {
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel() {
        this.close()
      }
    }
  }
</script>